import Local from './local';
import Prod from './prod';
import Stage from './stage';
import Master from './master';

let config = {};
switch (true) {
  case window.location.host.indexOf('localhost') !== -1:
    config = Local;
    break;
  case window.location.host.indexOf('stage') !== -1:
    config = Stage;
    break;
  case window.location.host.indexOf('master') !== -1:
    config = Master;
    break;

  default:
    config = Prod;
    break;
}

export default config;
